const { createTheme } = require("@mui/material/styles");
const breakpoints = {
	values: {
		xs: 0,
		sm: 960,
		md: 1200,
		lg: 1350,
		xl: 1420,
	},
};
const defaultTheme = createTheme({
	breakpoints,
});

const standardFontsSerif = ["Georgia", "Times New Roman", "Times", "serif"];
const standardFontsSans = [
	"-apple-system",
	"BlinkMacSystemFont",
	'"Segoe UI"',
	'"Helvetica Neue"',
	"Arial",
	"sans-serif",
	'"Apple Color Emoji"',
	'"Segoe UI Emoji"',
	'"Segoe UI Symbol"',
];

const themeConfig = {
	breakpoints,
	containerMaxWidths: {
		xs: "100%",
		sm: "880px",
		md: "1200px",
		lg: "1200px",
		xl: "1200px",
	},
	typography: {
		fontFamily: ["Hind", ...standardFontsSans].join(","),
		h1: {
			fontFamily: ["Lora", ...standardFontsSerif].join(","),
			fontWeight: 600,
		},
		h2: {
			fontFamily: ["Lora", ...standardFontsSerif].join(","),
			fontWeight: 600,
		},
		h3: {
			fontFamily: ["Lora", ...standardFontsSerif].join(","),
			fontWeight: 600,
		},
		h4: {
			fontFamily: ["Hind", ...standardFontsSans].join(","),
			fontWeight: 600,
		},
		overline: {
			fontSize: "0.8rem",
			letterSpacing: "0",
		},
		nav: {
			fontFamily: ["Hind", ...standardFontsSans].join(","),
			textTransform: "uppercase",
			fontWeight: 600,
			fontSize: "1rem",
		},
		subnav: {
			textTransform: "none",
		},
		toolsNav: {
			fontFamily: ["Hind", ...standardFontsSans].join(","),
			textTransform: "uppercase",
			fontWeight: 400,
			fontSize: "0.875rem",
		},
	},
	palette: {
		divider: "rgba(0, 0, 0, 0.12)",
		primary: {
			main: "#89b3d2",
			light: "#97c0de",
			dark: "#6d9ec2",
			contrastText: "#ffffff",
		},
		dark: {
			main: "#212121",
			light: "#424242",
			dark: "#000000",
			contrastText: "#ffffff",
		},
		secondary: {
			main: "#376299",
			light: "#4a79b5",
			dark: "#254773",
			contrastText: "#fff",
		},
		closingHeadings: {
			main: "#89b3d2",
			contrastText: "#fff",
		},
		closingHeadingsSecond: {
			main: "#376299",
			contrastText: "#fff",
		},
		excerptLink: {
			main: "rgba(0, 0, 0, 0.87)",
			hover: "rgba(0, 0, 0, 0.67)",
		},
		tab: {
			paper: "#eeeeee",
			main: "#eeeeee",
			contrastText: "#212121",
			hover: "#212121",
			contrastTextHover: "#eeeeee",
		},
		subnav: {
			main: "#fafafa",
			contrastText: "#757575",
		},
		amber: {
			main: "#e6c281",
			light: "#dbc49a",
			dark: "#b89961",
			contrastText: "#fff",
		},
		footer: {
			main: "#565656",
			light: "#565656",
			dark: "#565656",
			link: "#C9C9C9",
			linkHover: "#fafafa",
			contrastText: "#fafafa",
		},
		colophon: {
			main: "#565656",
			light: "#565656",
			dark: "#565656",
			contrastText: "#fafafa",
		},
		appBar: {
			private: {
				main: "#fff",
				light: "#fff",
				dark: "#fff",
				contrastText: "#2c2c2c",
			},
			public: {
				main: "#ffffff",
				light: "#ffffff",
				dark: "#eeeeee",
				contrastText: "#424242",
			},
		},
		titleBar: {
			public: {
				main: "#376299",
				light: "#376299",
				dark: "#376299",
				contrastText: "#fff",
			},
		},
		body: {
			main: "#f5f5f5",
			light: "#f5f5f5",
			dark: "#f5f5f5",
			contrastText: "#2c2c2c",
		},
	},
	cloverleaf: {
		googleFont: "Hind:wght@400;600&family=Lora:ital@0;1",
		closingHeadingsStyled: true,
		list: {
			underline: "#376299",
			underlineStyle: "square",
		},
		brand: {
			size: 96,
		},
		highlight: {
			inlineButtonsThreshold: 2,
		},
		navbar: {
			borderRadius: 10,
      align: "right",
		},
		css: `
      #___gatsby .desktop-nav {
        position: relative;
      }
      #___gatsby > div > footer {
            border-top: 20px solid #89b3d2;
      }
      #___gatsby .desktop-nav::before {
        content: " ";
        position: absolute;
        top: -2px;
        left: 0;
        width: 100%;
        height: 1px;
        background-image: -webkit-gradient(
          linear,
          left top,
          right top,
          color-stop(28%, rgba(255, 255, 255, 0.01)),
          to(#e6c281)
        );
        background-image: linear-gradient(90deg, rgba(255, 255, 255, 0.01) 28%, #e6c281);
        z-index: 1;
      }
      #___gatsby .cta-column > div {
        max-width: 100%;
      }
      #___gatsby .cta-wrap .content-row {
        text-align: left;
        text-shadow: 2px 2px 3px #76797a;
      }
      #___gatsby .footer .footer-submenu .MuiTypography-overline {
        font-size: 1rem;
        font-weight: 600;
      }
      #___gatsby time.MuiTypography-overline {
        font-size: 1rem;
      }
    `,
	},
};
module.exports = themeConfig;
